// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__tHHLy","approved":"Status_approved__29pTx","rejected":"Status_rejected__3pVCz","expired":"Status_expired__siTgr","label":"Status_label__1asRf"};